import { useAuthState } from '@creditornot/wolt-auth/react';
import { useMemo } from 'react';

/**
 * TODO: reference shared countries config instead when it's available
 */

const requiredCookieConsentCountries: { [key in Country]: { requiresCookieConsent: boolean } } = {
  ALB: { requiresCookieConsent: true },
  AUT: { requiresCookieConsent: true },
  AZE: { requiresCookieConsent: false },
  CYP: { requiresCookieConsent: true },
  CZE: { requiresCookieConsent: true },
  DEU: { requiresCookieConsent: true },
  DNK: { requiresCookieConsent: true },
  EST: { requiresCookieConsent: true },
  FIN: { requiresCookieConsent: true },
  GEO: { requiresCookieConsent: false },
  GRC: { requiresCookieConsent: true },
  HRV: { requiresCookieConsent: true },
  HUN: { requiresCookieConsent: true },
  ISL: { requiresCookieConsent: true },
  ISR: { requiresCookieConsent: false },
  JPN: { requiresCookieConsent: true },
  KAZ: { requiresCookieConsent: false },
  LUX: { requiresCookieConsent: true },
  LTU: { requiresCookieConsent: true },
  LVA: { requiresCookieConsent: true },
  MLT: { requiresCookieConsent: true },
  NOR: { requiresCookieConsent: true },
  POL: { requiresCookieConsent: true },
  SRB: { requiresCookieConsent: true },
  SVK: { requiresCookieConsent: true },
  SVN: { requiresCookieConsent: true },
  SWE: { requiresCookieConsent: true },
  UZB: { requiresCookieConsent: true },
} as const;

export const useShowConsentsModal = () => {
  const { user } = useAuthState();

  return useMemo((): boolean => {
    if (!user) {
      return true;
    }

    const castedCookieCountries = requiredCookieConsentCountries as {
      [key: string]: { requiresCookieConsent: boolean };
    };

    // If the user's country is not in the list for some reason, default to showing them the cookie consent modal. Better safe than sorry
    const cookieConsentEntry = castedCookieCountries[user.country] || { requiresCookieConsent: true };
    const { requiresCookieConsent } = cookieConsentEntry;

    return requiresCookieConsent;
  }, [user]);
};
